export const LAYOUT = {
  MOBILE_WIDTH: 390,
  CONTENT_WIDTH: 366, // MOBILE_WIDTH - (2 * PADDING)
  PADDING: 12,
  HEADER_HEIGHT: 56,
  SUBHEADER_HEIGHT: 48,
  BOTTOM_NAV_HEIGHT: 56
}; 